import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebook, FaLinkedin } from 'react-icons/fa';
import { FaYoutube } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { siteConfig } from '../config/siteConfig';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary-dark text-white py-16 px-8 mt-auto">
      <div className="max-w-container mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
        <div className="space-y-6">
          <h3 className="text-white text-lg font-medium uppercase tracking-wider">{t('footer.sections.about.title')}</h3>
          <ul className="space-y-3">
            <li><Link to={siteConfig.buttonLinks.home} className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('footer.sections.about.home')}</Link></li>
            <li><Link to={siteConfig.buttonLinks.ourHistory} className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('footer.sections.about.history')}</Link></li>
            <li><Link to={siteConfig.buttonLinks.galeria} className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('footer.sections.about.gallery')}</Link></li>
          </ul>
        </div>

        <div className="space-y-6">
          <h3 className="text-white text-lg font-medium uppercase tracking-wider">{t('footer.sections.accommodation.title')}</h3>
          <ul className="space-y-3">
            <li><Link to={siteConfig.buttonLinks.accommodation} className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('footer.sections.accommodation.rooms')}</Link></li>
            <li><Link to={siteConfig.buttonLinks.areasExternas} className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('footer.sections.accommodation.lodge')}</Link></li>
            <li><Link to={siteConfig.buttonLinks.gastronomy} className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('footer.sections.accommodation.gastronomy')}</Link></li>
            <li><Link to={siteConfig.buttonLinks.eventosNatureza} className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('footer.sections.accommodation.natureEvents')}</Link></li>
          </ul>
        </div>

        <div className="space-y-6">
          <h3 className="text-white text-lg font-medium uppercase tracking-wider">{t('footer.sections.experiences.title')}</h3>
          <ul className="space-y-3">
            <li><Link to={siteConfig.buttonLinks.birdwatching} className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('footer.sections.experiences.birdwatching')}</Link></li>
            <li><Link to={siteConfig.buttonLinks.primates} className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('footer.sections.experiences.primates')}</Link></li>
            <li><Link to={siteConfig.buttonLinks.safariBoat} className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('footer.sections.experiences.safariBoat')}</Link></li>
            <li><Link to={siteConfig.buttonLinks.trilhas} className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('footer.sections.experiences.trails')}</Link></li>
            <li><Link to={siteConfig.buttonLinks.guiasCampo} className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('footer.sections.experiences.fieldGuides')}</Link></li>
          </ul>
        </div>

        <div className="space-y-6">
          <h3 className="text-white text-lg font-medium uppercase tracking-wider">{t('footer.sections.information.title')}</h3>
          <ul className="space-y-3">
            <li><Link to="/como-chegar" className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('navigation.howToGet')}</Link></li>
            <li><Link to="/faq" className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('navigation.frequentlyAskedQuestions')}</Link></li>
            <li><Link to="/privacy-policy" className="text-white/80 hover:text-white transition-default text-[0.95rem]">{t('footer.sections.information.privacyPolicy')}</Link></li>
          </ul>
        </div>

        <div className="space-y-6">
          <h3 className="text-white text-lg font-medium uppercase tracking-wider">{t('footer.sections.contact.title')}</h3>
          <ul className="space-y-3">
            <li>
              <strong className="text-white font-medium">{t('footer.sections.contact.email')}</strong>
              <a href={`mailto:${siteConfig.buttonLinks.email}`} className="text-white/80 hover:text-white transition-default text-[0.95rem] ml-1">
                atendimento@jardimdaamazonia.com
              </a>
            </li>
            <li>
              <strong className="text-white font-medium">{t('footer.sections.contact.whatsapp')}</strong>
              <a href={siteConfig.buttonLinks.whatsapp} target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-default text-[0.95rem] ml-1">
                +55 65 4042-0595
              </a>
            </li>
            <li>
              <strong className="text-white font-medium">Suporte Regional / Nelson:</strong>
              <a href={siteConfig.buttonLinks.whatsappSuporteRegional} target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-default text-[0.95rem] ml-1">
                +55 65 99819-8831
              </a>
            </li>
          </ul>
        </div>

        <div className="space-y-6">
          <h3 className="text-white text-lg font-medium uppercase tracking-wider">{t('footer.sections.activePresence.title')}</h3>
          <ul className="space-y-3">
            <li>
              <Link to="/cop30-retreat" className="text-white/80 hover:text-white transition-default text-[0.95rem]">
                {t('footer.sections.activePresence.cop30Retreat')}
              </Link>
            </li>
            <li>
              <Link to="/global-big-day" className="text-white/80 hover:text-white transition-default text-[0.95rem]">
                {t('footer.sections.activePresence.globalBigDay')}
              </Link>
            </li>
            <li>
              <Link to="/photo-upload" className="text-white/80 hover:text-white transition-default text-[0.95rem]">
                {t('footer.sections.activePresence.photoUpload')}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* New Feedback Link Section */}
      <div className="max-w-container mx-auto text-center mb-8">
        <div className="flex flex-col items-center gap-2">
          <div className="text-white/90 text-base font-medium mb-1">{t('footer.sections.information.helpUsImprove')}</div>
          <a 
            href="mailto:adm@jardimdaamazonia.com?subject=WEBSITE:%20Ideias%20ou%20sugestões%20/%20Ideas%20or%20suggestions"
            className="text-white/80 hover:text-white transition-default text-sm mb-2"
          >
            {t('footer.sections.information.websiteFeedback')}
          </a>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLScnBo5qJUKQ0dVzoEl3WfDAXP_LXPB09nnjghGjOafFZajWPg/viewform?usp=sharing&ouid=103761340795783574359"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-primary-dark font-bold px-7 py-3 rounded-lg shadow-lg hover:bg-primary-light hover:text-white transition-default text-base mt-2"
          >
            {t('footer.sections.information.reviewExperience')}
          </a>
        </div>
      </div>

      <div className="border-t border-white/10 pt-8 text-center">
        <div className="flex justify-center gap-6 mb-6">
          <a
            href={siteConfig.buttonLinks.instagram}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="text-white text-2xl hover:opacity-80 transition-default"
          >
            <FaInstagram className="w-5 h-5" />
          </a>
          <a
            href={siteConfig.buttonLinks.facebook}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="text-white text-2xl hover:opacity-80 transition-default"
          >
            <FaFacebook className="w-5 h-5" />
          </a>
          <a
            href={siteConfig.buttonLinks.youtube}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
            className="text-white text-2xl hover:opacity-80 transition-default"
          >
            <FaYoutube className="w-5 h-5" />
          </a>
          <a
            href="https://www.linkedin.com/company/jardim-da-amazonia/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="text-white text-2xl hover:opacity-80 transition-default"
          >
            <FaLinkedin className="w-5 h-5" />
          </a>
        </div>
        <p className="text-white/60 text-sm">
          {t('footer.copyright')}
        </p>
        <p className="text-white/40 text-xs mt-2 text-center">Site desenvolvido por JPZank</p>
      </div>
    </footer>
  );
}

export default Footer; 